<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout wrap justify-center fill-height>
      <v-flex xs12 sm12 md12 lg12>
        <v-img
          class="hidden-md-and-down"
          height="350px"
          :style="
            $vuetify.breakpoint.name == 'xs'
              ? 'height: 1500px'
              : $vuetify.breakpoint.name == 'sm'
              ? 'height: 700px'
              : $vuetify.breakpoint.name == 'md'
              ? 'height: 700px'
              : $vuetify.breakpoint.name == 'lg'
              ? 'height: 350px'
              : $vuetify.breakpoint.name == 'xl'
              ? 'height: 350px'
              : (style = 'height: 100%')
          "
          src="../../assets/images/Asset 1.png"
        >
          <v-layout justify-center wrap>
            <v-flex xs8 sm8 md8>
              <v-layout justify-center wrap pt-10 class="hidden-sm-and-down">
                <v-flex xs12 sm12 md12 lg12 pl-2 text-left>
                  <router-link
                    :to="'/appDashboard'"
                    style="text-decoration: none"
                  >
                    <span
                      style="
                        font-family: nunitosansextrabold;
                        color: white;
                        font-size: 22px;
                      "
                      >Dashboard</span
                    ><br />
                    <span v-if="user.school"
                      style="
                        font-family: nunitosansregular;
                        color: white;
                        font-size: 14px;
                      "
                      >{{user.school.name}}</span
                    >
                  </router-link>
                </v-flex>
              </v-layout>
              <v-layout justify-center wrap pt-12 class="hidden-md-and-up">
                <v-flex xs12 sm12 md12 lg12 text-left pt-10>
                  <router-link
                    :to="'/appDashboard'"
                    style="text-decoration: none"
                  >
                    <span
                      style="
                        font-family: nunitosansextrabold;
                        color: white;
                        font-size: 22px;
                      "
                      >Dashboard</span
                    ><br />
                    <span v-if="user.school"
                      style="
                        font-family: nunitosansregular;
                        color: white;
                        font-size: 14px;
                      "
                      >{{user.school.name}}</span
                    >
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout justify-center wrap py-2>
            <v-flex xs12 sm12 md12 lg12 xl12 px-lg-12 px-xl-12 pb-12>
              <v-layout justify-center wrap>
                <v-flex
                  align-self-center
                  pa-1
                  pl-3
                  pl-xl-0
                  v-for="(item, i) in card"
                  :key="i"
                >
                  <!-- <v-card> -->
                  <v-layout justify-center wrap>
                    <v-flex align-self-center px-xl-12 py-xl-4>
                      <!-- <v-overlay absolute dark color="transperent"> -->
                      <v-card
                        :to="item.to"
                        elevation="2"
                        color="white"
                        hover
                        :ripple="false"
                        max-height="200"
                        :max-width="
                          $vuetify.breakpoint.name == 'xl' ? '100%' : '152'
                        "
                      >
                        <v-card-text
                          style="overflow-y: auto; height: 180px; width: 170px"
                        >
                          <v-img width="40px" :src="item.img"></v-img>
                          <v-flex xs12 pt-2>
                            <span class="title1">{{
                              item.title.slice(0, 50)
                            }}</span>
                          </v-flex>
                          <v-flex xs12 pt-5 v-if="i == 3">
                            <span class="text1">{{ notice }} Latest Notice<span v-if="notice>1">s</span></span>
                          </v-flex>
                          <v-flex xs12 pt-5 v-else>
                            <span class="text1">{{ item.text }}</span>
                          </v-flex>
                        </v-card-text>
                      </v-card>
                      <!-- </v-overlay> -->
                    </v-flex>
                  </v-layout>
                  <!-- </v-card> -->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-img>
        <v-img
          class="hidden-lg-and-up"
          :style="
            $vuetify.breakpoint.name == 'xs'
              ? 'height: 1725px'
              : $vuetify.breakpoint.name == 'sm'
              ? 'height: 600px'
              : $vuetify.breakpoint.name == 'md'
              ? 'height: 510px'
              : $vuetify.breakpoint.name == 'lg'
              ? 'height: 820px'
              : (style = 'height: 100%')
          "
          src="../../assets/images/Asset 1.png"
        >
          <v-layout justify-center wrap>
            <v-flex xs8 sm8 md8>
              <v-layout justify-center wrap pt-1 class="hidden-sm-and-down">
                <v-flex xs12 sm12 md12 lg12 text-left>
                  <router-link
                    :to="'/appDashboard'"
                    style="text-decoration: none"
                  >
                    <span
                      style="
                        font-family: nunitosansextrabold;
                        color: white;
                        font-size: 22px;
                      "
                      >Dashboard</span
                    ><br />
                    <span v-if="user.school"
                      style="
                        font-family: nunitosansregular;
                        color: white;
                        font-size: 14px;
                      "
                      >{{user.school.name}}</span
                    >
                  </router-link>
                </v-flex>
              </v-layout>
              <v-layout
                justify-start
                wrap
                pt-12
                style="padding-top: 90px !important"
                class="hidden-md-and-up"
              >
                <v-flex xs12 sm12 md12 lg12 text-left>
                  <router-link
                    :to="'/appDashboard'"
                    style="text-decoration: none"
                  >
                    <span
                      style="
                        font-family: nunitosansextrabold;
                        color: white;
                        font-size: 22px;
                      "
                      >Dashboard</span
                    ><br />
                    <span v-if="user.school"
                      style="
                        font-family: nunitosansregular;
                        color: white;
                        font-size: 14px;
                      "
                      >{{user.school.name}}</span
                    >
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout justify-center wrap>
            <v-flex xs12 sm12 md12 pb-12 pt-5>
              <v-layout justify-center wrap>
                <v-flex
                  align-self-center
                  px-5
                  pb-5
                  xs12
                  sm3
                  md3
                  v-for="(item, i) in card"
                  :key="i"
                >
                  <v-card
                    elevation="2"
                    color="white"
                    hover
                    :ripple="false"
                    max-height="200"
                    :max-width="
                      $vuetify.breakpoint.name == 'xs' ? '100%' : '350'
                    "
                    style="border: 9px solid red"
                  >
                    <v-card-text style="height: 180px; width: 170px">
                      <v-img width="40px" :src="item.img"></v-img>
                      <v-flex xs12 pt-2>
                        <span class="title1">{{ item.title }}</span>
                      </v-flex>
                      <v-flex xs12 pt-5 v-if="i == 3">
                        <span class="text1">{{ notice}} Latest Notices<span v-if="notice>1">s</span></span>
                      </v-flex>
                      <v-flex xs12 pt-5 v-else>
                        <span class="text1">{{ item.text }}</span>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-img>
        <v-layout
          v-if="
            $route.name != 'Student List' &&
            $route.name != 'Student Details' &&
            $route.name != 'Add Student' &&
            $route.name != 'View Student' &&
            $route.name != 'Staff List' &&
            $route.name != 'Staff Details' &&
            $route.name != 'Add Staff' &&
            $route.name != 'Add Class' &&
            $route.name != 'Add Class Teacher' &&
            $route.name != 'View Class' &&
            $route.name != 'Analytics' &&
            $route.name != 'noticeboard2' &&
            $route.name != 'noticeview' &&
            $route.name != 'noticeEdit' &&
            $route.name != 'noticeadd' &&
            $route.name != 'addSubject' &&
            $route.name != 'viewSubject' &&
            $route.name != 'addexam' &&
            $route.name != 'viewExam' &&
            $route.name != 'Topper Video' &&
            $route.name != 'Topper Video Details' &&
            $route.name != 'View More'  &&
            $route.name != 'View Attendance'  &&
            $route.name != 'Profile'
          "
          justify-center
          pa-5
          wrap
          pt-5
        >
          <v-flex xs12 sm8 md8>
            <Attendence />
          </v-flex>
        </v-layout>
        <v-layout
          v-if="
            $route.name != 'Student List' &&
            $route.name != 'Student Details' &&
            $route.name != 'Add Student' &&
            $route.name != 'View Student' &&
            $route.name != 'Staff List' &&
            $route.name != 'Staff Details' &&
            $route.name != 'Add Staff' &&
            $route.name != 'Add Class' &&
            $route.name != 'Add Class Teacher' &&
            $route.name != 'View Class' &&
            $route.name != 'Analytics' &&
            $route.name != 'noticeboard2' &&
            $route.name != 'noticeview' &&
            $route.name != 'noticeEdit' &&
            $route.name != 'noticeadd' &&
            $route.name != 'addSubject' &&
            $route.name != 'viewSubject' &&
            $route.name != 'addexam' &&
            $route.name != 'viewExam' &&
            $route.name != 'Topper Video' &&
            $route.name != 'Topper Video Details' &&
            $route.name != 'View More' &&
            $route.name != 'View Attendance' &&
            $route.name != 'Profile'
          "
          justify-center
          wrap
          pa-5
          pt-4
        >
          <v-flex xs12 sm8 md8>
            <Noticeboard/>
          </v-flex>
        </v-layout>
        <v-layout justify-center wrap pa-5 pt-8>
          <v-flex xs12 sm8 md10 lg8>
            <router-view> </router-view>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import Attendence from "@/components/Attendence/attendence";
import Noticeboard from "@/components/Noticeboard/noticeboard";
export default {
  components: {
    Attendence,
    Noticeboard,
  },
  data() {
    return {
      hover: false,
      appLoading: false,
      ServerError: false,
      attendence: [],
      notice:[],
      user:[],
      myText: "",
      card: [
        {
          img: require("../../assets/images/Group 281.png"),
          title: "Analytics",
          text: "School Performance",
          to: "/analytics",
        },
        {
          img: require("../../assets/images/Group 282.png"),
          title: "Student List",
          text: "View/Add Student Profile",
          to: "/studentList",
        },
        {
          img: require("../../assets/images/Group 283.png"),
          title: "Staff List",
          text: "Teaching & Non Teaching Staff",
          to: "/staffList",
        },
        {
          img: require("../../assets/images/Group 284.png"),
          title: "Noticeboard",
          text: "2 Latest Notices",
          to: "/noticeboard2",
        },
        {
          img: require("../../assets/images/Group 285.png"),
          title: "Class & Teacher",
          text: "Add / View",
          to: "/addClass",
        },
        {
          img: require("../../assets/images/Asset 83.svg"),
          title: "Subject",
          text: "Add / View",
          to: "/viewSubject",
        },
        {
          img: require("../../assets/images/Asset 82.svg"),
          title: "Exam",
          text: "Add / View",
          to: "/viewexam",
        },
      ],
      searchKey: null,
    };
  },
  mounted() {
    this.getData()
    this.getProfile()
  },
  methods: {
    winStepperN(windowData) {
      if (windowData) {
        alert("mh")
        this.myText = windowData.myText.latestNoticeCount;
      }
    },
     getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/notice/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.notice = response.data.latestNoticeCount
          console.log(this.notice);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
      getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.user = response.data.data;
            // this.userStatus = this.user.status;
            console.log(this.user);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.title1 {
  color: black;
  font-family: nunitosanssemibold;
  size: 10px;
}
.text1 {
  color: #606060;
  font-family: nunitosansregular;
}
</style>
